











































import { Component, Vue } from 'vue-property-decorator'
import { DEFAULT_WIDGET } from '@/_consts/WidgetDefault'
import { WidgetModel } from '@/_models/WidgetModel'

@Component({
  components: {},
})
export default class PreviewWidget extends Vue {
  defaultsWidtget = DEFAULT_WIDGET
  countHeight = 0

  get widgetSettingsData(): WidgetModel[] {
    return this.$store.state.settings.widgets.sort((a, b) => +a.order - +b.order)
  }

  get formatDataIntoGrids() {
    const dataGrids: any[] = []
    // Reset when count
    this.countHeight = 0
    let countHeightSingleFull = 0
    let countHeightWidthSingle = 0

    for (const element of this.widgetSettingsData) {
      const isWidthFull = element.width === 'full'
      const isHeightFull = element.height === 'full'
      this.countHeight += isHeightFull ? 2 : 1

      if (isWidthFull && isHeightFull) {
        dataGrids.push({
          ...element,
          row: 'span 2',
          column: 'span 2',
        })
      } else if (isWidthFull || isHeightFull) {
        countHeightSingleFull += isHeightFull ? 1 : 0
        dataGrids.push(this.calcPositionForItem(element, isWidthFull))
      } else {
        countHeightWidthSingle += 1
        dataGrids.push(element)
      }
    }

    this.countHeight -= Math.trunc(countHeightSingleFull / 2) * 2 + Math.trunc(countHeightWidthSingle / 2)

    return dataGrids
  }

  public calcPositionForItem(element: WidgetModel, isWidthFull: boolean) {
    return {
      ...element,
      column: isWidthFull ? 'span 2' : 'span 1',
      row: isWidthFull ? 'span 1' : 'span 2',
    }
  }
}
